// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually
import React from 'react';

const IconCheck = (props: React.SVGProps<SVGElement>) =>
  /*#__PURE__*/ React.createElement(
    'svg',
    {
      width: '15',
      height: '14',
      viewBox: '0 0 15 14',
      xmlns: 'http://www.w3.org/2000/svg',
      ...props
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M1.75 7.84797C2.9268 8.70383 5.28041 11.0574 6.24324 12.6622C7.42005 10.0946 10.4155 4.31757 13.625 1.75',
      stroke: 'current',
      strokeWidth: '2',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    })
  );

export { IconCheck };
